import { Checkbox, FormControlLabel } from "@mui/material";

const MCHComponent = (props) => {
  const { question } = props;
  return (
    <>
      <fieldset
        style={{ borderWidth: "thin" }}
        className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
      >
        {question.answers.map((ans, index) => (
          <FormControlLabel
            key={ans.id}
            style={{ width: "100%" }}
            control={
              <Checkbox
                key={ans.id + index}
                checked={false}
                //onChange={handleChange}
                name={ans.text}
                color="primary"
              />
            }
            label={ans?.text + "(" + ans.value + ")"}
          />
        ))}
      </fieldset>
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default MCHComponent;
